module.exports = __webpack_public_path__ + "static/media/hat.b86661fe.png";